/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import * as fromSharedStore from 'app/shared/store';
import { FormHelpersService, WebsocketsService } from 'app/shared/services';
import { UserData } from '../../models/user.model';

@Component({
  selector: '[loginForm]',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
})
export class LoginFormComponent implements OnDestroy, OnInit {
  @ViewChild('submitBtn') submitBtn: ElementRef;
  @Input() showCreateAccount = false;
  @Input() isLoggingIn = false;
  @Output() loginSuccess: EventEmitter<any> = new EventEmitter();
  @Output() goToSignup: EventEmitter<any> = new EventEmitter();

  loginForm: FormGroup;
  userData: UserData;
  errorMessage: string;
  showPassword: boolean;

  private componentDestroyed: Subject<any> = new Subject();

  constructor(
    public formHelperService: FormHelpersService,
    private sharedStore: Store<fromSharedStore.SharedState>,
    private wsService: WebsocketsService
  ) {}

  ngOnInit() {
    this.loginForm = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9._+-]{1,}@{1}[a-zA-Z0-9.-]{1,}[.]{1}[a-zA-Z+]{2,}'),
      ]),
      password: new FormControl('', Validators.required),
      rememberMe: new FormControl(false),
    });

    this.sharedStore
      .select(fromSharedStore.getUserFail)
      .pipe(
        filter((data) => data.failed),
        takeUntil(this.componentDestroyed)
      )
      .subscribe((data) => {
        this.errorMessage = data.message;
        this.isLoggingIn = false;
      });

    this.sharedStore
      .select(fromSharedStore.getUserData)
      .pipe(
        filter((data) => data.success),
        takeUntil(this.componentDestroyed)
      )
      .subscribe((data) => {
        if (this.isLoggingIn) {
          // load user invites
          this.sharedStore.dispatch(new fromSharedStore.GetUserInvites({ id: data.userData.id }));
          this.wsService.registerAsUser(data.userData.id);
          this.loginSuccess.emit();
        }
      });
  }

  ngOnDestroy() {
    this.componentDestroyed.next();
    this.componentDestroyed.complete();
  }

  // Login using username and password
  doLogin($event) {
    $event.preventDefault();
    this.submitBtn.nativeElement.focus();

    if (this.loginForm.invalid) {
      return;
    }

    this.isLoggingIn = true;
    this.sharedStore.dispatch(new fromSharedStore.UserLogin(this.loginForm.getRawValue()));
  }

  toggleShowPassword() {
    this.showPassword = true;
  }

  toggleHidePassword() {
    this.showPassword = false;
  }

  createAccount($event) {
    $event.preventDefault();
    this.goToSignup.emit();
  }
}
